/* MARIE SOPHIE — Theme JS. Vanilla, keine Abhängigkeiten. */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  /* ---------------- Header ---------------- */
  function header() {
    var el = document.querySelector('[data-header]');
    if (!el) return;
    var last = 0;
    function tick() {
      var y = window.scrollY;
      el.classList.toggle('is-solid', y > 24);
      el.classList.toggle('is-hidden', y > 260 && y > last && !document.body.classList.contains('is-locked'));
      last = y;
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });

    var burger = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-mmenu]');
    if (burger && menu) {
      var toggle = function (open) {
        menu.classList.toggle('is-open', open);
        document.body.classList.toggle('is-locked', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          menu.querySelectorAll('.mmenu__list a').forEach(function (a, i) {
            a.style.animationDelay = 120 + i * 55 + 'ms';
          });
        }
      };
      burger.addEventListener('click', function () { toggle(!menu.classList.contains('is-open')); });
      menu.querySelectorAll('[data-mclose]').forEach(function (b) {
        b.addEventListener('click', function () { toggle(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') toggle(false);
      });
    }
  }

  /* ---------------- Hero-Slideshow ---------------- */
  function hero() {
    var root = document.querySelector('[data-hero]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero__slide'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('.hero__bar'));
    if (slides.length < 2) { if (bars[0]) bars[0].classList.add('is-done'); return; }
    var dur = parseInt(root.dataset.duration || '6500', 10);
    var i = 0, timer = null;

    function show(n) {
      slides[i].classList.remove('is-on');
      bars.forEach(function (b) { b.classList.remove('is-on', 'is-done'); });
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on');
      for (var k = 0; k < i; k++) bars[k].classList.add('is-done');
      // Reflow, damit die Balken-Animation neu startet
      void bars[i].offsetWidth;
      bars[i].classList.add('is-on');
    }
    function play() { if (!RM) timer = setInterval(function () { show(i + 1); }, dur); }
    function stop() { clearInterval(timer); }

    slides[0].classList.add('is-on');
    bars[0].classList.add('is-on');
    play();

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : (stop(), play());
    });
    bars.forEach(function (b, n) {
      b.addEventListener('click', function () { stop(); show(n); play(); });
    });
  }

  /* ---------------- Scroll-Reveals ---------------- */
  function reveals() {
    var items = document.querySelectorAll('.rv, .rv-img');
    if (!items.length) return;
    if (RM || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Accordion ---------------- */
  function accordions() {
    document.querySelectorAll('[data-acc-t]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.acc__i');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- PDP-Galerie (mobil) ---------------- */
  function gallery() {
    var gal = document.querySelector('[data-gal]');
    var dots = document.querySelector('[data-gal-dots]');
    if (!gal || !dots) return;
    var figs = gal.querySelectorAll('.gal__f');
    gal.addEventListener('scroll', function () {
      var n = Math.round(gal.scrollLeft / (gal.scrollWidth / figs.length));
      dots.querySelectorAll('.gal__dot').forEach(function (d, k) {
        d.classList.toggle('is-on', k === n);
      });
    }, { passive: true });
  }

  /* ---------------- Varianten-Auswahl ---------------- */
  function variants() {
    document.querySelectorAll('[data-variants]').forEach(function (form) {
      var data = JSON.parse(form.querySelector('[data-variant-json]').textContent);
      var idIn = form.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-price]');
      var barPrice = document.querySelector('[data-bar-price]');
      var btn = form.querySelector('[data-add]');
      var note = document.querySelector('[data-stock-note]');

      function selected() {
        return Array.prototype.map.call(form.querySelectorAll('[data-opt]:checked'), function (i) { return i.value; });
      }
      function match(sel) {
        return data.find(function (v) {
          return v.options.length === sel.length && v.options.every(function (o, k) { return o === sel[k]; });
        });
      }
      function refresh() {
        var sel = selected();
        // Verfügbarkeit je Option gegen die übrigen Auswahlen prüfen
        form.querySelectorAll('[data-opt]').forEach(function (input) {
          var idx = parseInt(input.dataset.optIndex, 10);
          var test = sel.slice();
          test[idx] = input.value;
          var v = data.find(function (x) { return x.options[idx] === input.value && x.options.every(function (o, k) { return k === idx || o === test[k]; }); });
          input.disabled = !v || !v.available;
        });

        var v = match(selected());
        if (!v) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; return; }
        idIn.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (barPrice) barPrice.textContent = money(v.price);
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        if (note) note.textContent = v.available ? '' : 'Diese Größe ist derzeit nicht auf Lager.';
      }

      form.querySelectorAll('[data-opt]').forEach(function (i) { i.addEventListener('change', refresh); });
      refresh();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idIn.value, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { return refreshCart(); })
          .then(function () { openCart(); btn.textContent = label; btn.disabled = false; })
          .catch(function () {
            btn.textContent = 'Nicht hinzugefügt — bitte erneut versuchen';
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2600);
          });
      });
    });
  }

  /* ---------------- Quick-Add im Grid ---------------- */
  function quickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qa-add]');
      if (!b) return;
      e.preventDefault();
      var prev = b.textContent;
      b.textContent = '·';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: b.dataset.qaAdd, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return refreshCart(); })
        .then(function () { b.textContent = prev; openCart(); })
        .catch(function () { b.textContent = '×'; setTimeout(function () { b.textContent = prev; }, 1800); });
    });
  }

  /* ---------------- Warenkorb-Drawer ---------------- */
  function openCart() {
    var d = document.querySelector('[data-drawer]');
    var s = document.querySelector('[data-scrim]');
    if (!d) return;
    d.classList.add('is-on'); if (s) s.classList.add('is-on');
    document.body.classList.add('is-locked');
    d.setAttribute('aria-hidden', 'false');
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeCart() {
    var d = document.querySelector('[data-drawer]');
    var s = document.querySelector('[data-scrim]');
    if (!d) return;
    d.classList.remove('is-on'); if (s) s.classList.remove('is-on');
    document.body.classList.remove('is-locked');
    d.setAttribute('aria-hidden', 'true');
  }
  function refreshCart() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var host = document.querySelector('[data-drawer-host]');
        if (!host || !j['cart-drawer']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = j['cart-drawer'];
        var fresh = tmp.querySelector('[data-drawer-host]');
        if (fresh) host.innerHTML = fresh.innerHTML;
        var n = host.querySelector('[data-count-src]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = n ? n.dataset.countSrc : '0';
        });
      });
  }

  function cartEvents() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openCart); }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-scrim]')) closeCart();

      var q = e.target.closest('[data-qty]');
      if (q) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(q.dataset.line, 10), quantity: Math.max(0, parseInt(q.dataset.qtyVal, 10)) })
        }).then(refreshCart);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  /* ---------------- Sticky Kauf-Leiste ---------------- */
  function buyBar() {
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
    bar.querySelector('[data-bar-buy]').addEventListener('click', function () {
      anchor.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
      var first = document.querySelector('[data-opt]:not(:disabled):not(:checked)');
      setTimeout(function () {
        var add = document.querySelector('[data-add]');
        if (add && !add.disabled && document.querySelector('[data-opt]:checked')) add.click();
        else if (first) first.focus();
      }, RM ? 0 : 520);
    });
  }

  /* ---------------- Sortierung ---------------- */
  function sorting() {
    var s = document.querySelector('[data-sort]');
    if (!s) return;
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  function init() {
    header(); hero(); reveals(); accordions(); gallery();
    variants(); quickAdd(); cartEvents(); buyBar(); sorting();
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
